import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Layout from "@/components/Layout";
import { toast } from "sonner";
import { Plus, Trash, Prohibit } from "@phosphor-icons/react";

export default function Blocklist() {
  const [items, setItems] = useState([]);
  const [phone, setPhone] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/blocklist");
      setItems(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!phone.trim()) return toast.error("Informe um número");
    try {
      await api.post("/blocklist", {
        phone_number: phone.trim(),
        reason: reason.trim() || null,
      });
      toast.success("Número bloqueado");
      setPhone("");
      setReason("");
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Falha ao bloquear");
    }
  };

  const remove = async (id) => {
    if (!confirm("Remover bloqueio?")) return;
    try {
      await api.delete(`/blocklist/${id}`);
      toast.success("Bloqueio removido");
      load();
    } catch {
      toast.error("Falha ao remover");
    }
  };

  return (
    <Layout title="Bloqueios" subtitle="Anti-abuso">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="border border-[#E5E7EB] bg-white">
          <div className="px-5 py-4 border-b border-[#E5E7EB] flex items-center gap-2">
            <Prohibit size={20} weight="duotone" className="text-[#EF4444]" />
            <div className="font-display font-bold">Bloquear número</div>
          </div>
          <form onSubmit={add} className="p-5 space-y-3">
            <div>
              <label className="label-mono block mb-2">Número (com DDI)</label>
              <input
                data-testid="block-phone-input"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="5511999999999"
                className="w-full bg-white border border-[#E5E7EB] px-3 py-2 text-sm rounded-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7]"
              />
            </div>
            <div>
              <label className="label-mono block mb-2">Motivo (opcional)</label>
              <input
                data-testid="block-reason-input"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Spam, abuso..."
                className="w-full bg-white border border-[#E5E7EB] px-3 py-2 text-sm rounded-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7]"
              />
            </div>
            <button
              data-testid="block-add-btn"
              type="submit"
              className="w-full bg-[#002FA7] text-white text-sm font-medium py-2.5 rounded-sm hover:bg-[#001f7a] transition-colors duration-150 flex items-center justify-center gap-2"
            >
              <Plus size={16} weight="bold" /> Adicionar bloqueio
            </button>
          </form>
        </div>

        <div className="lg:col-span-2 border border-[#E5E7EB] bg-white">
          <div className="px-5 py-4 border-b border-[#E5E7EB]">
            <div className="label-mono">{items.length} números bloqueados</div>
          </div>
          <div className="divide-y divide-[#E5E7EB]">
            {loading && (
              <div className="px-5 py-10 text-center text-sm text-[#64748B]">Carregando…</div>
            )}
            {!loading && items.length === 0 && (
              <div className="px-5 py-10 text-center text-sm text-[#64748B]">
                Nenhum número bloqueado.
              </div>
            )}
            {items.map((b) => (
              <div
                key={b.id}
                data-testid={`block-row-${b.id}`}
                className="px-5 py-3 flex items-center justify-between hover:bg-[#F8F9FA] transition-colors duration-150"
              >
                <div>
                  <div className="text-sm mono text-[#0F172A]">{b.phone_number}</div>
                  <div className="text-xs text-[#64748B] mt-0.5">
                    {b.reason || "sem motivo"} ·{" "}
                    {new Date(b.created_at).toLocaleString("pt-BR")}
                  </div>
                </div>
                <button
                  data-testid={`block-remove-${b.id}`}
                  onClick={() => remove(b.id)}
                  className="text-[#EF4444] hover:underline flex items-center gap-1 text-xs"
                >
                  <Trash size={14} weight="bold" /> Remover
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}
